/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React, { ReactElement } from "react";

import { Redirect } from "react-router-dom";

import { Text } from "@fluentui/react";

import { useAuth } from "Authentication/AuthProvider";
import { DetailWrapper } from "Containers/Common/CommonContainer.styles";

const RegionalDirectorsEventContainer = (): ReactElement => {
  const { isUserLoggedIn, loading, hasAnyRoles } = useAuth();
  if (isUserLoggedIn && !hasAnyRoles && !loading) {
    return <Redirect to="/unauthorized" />;
  }

  return (
    <DetailWrapper>
      <div>
        <Text>Regional Directors Event Container</Text>
      </div>
      <div>
        <Text>Coming Soon</Text>
      </div>
    </DetailWrapper>
  );
};

export default RegionalDirectorsEventContainer;
